import React from 'react';
import { Mail, Phone } from 'lucide-react';
interface StorefrontFooterProps {
  supportEmail: string;
  supportPhone?: string;
}
export function StorefrontFooter({
  supportEmail,
  supportPhone
}: StorefrontFooterProps) {
  return <footer className="bg-gray-50 border-t border-gray-200 mt-12" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-225">
        <div className="text-center space-y-4" data-id="element-226">
          <h3 className="text-sm font-medium text-gray-900" data-id="element-227">Need Help?</h3>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6" data-id="element-228">
            <a href={`mailto:${supportEmail}`} className="flex items-center text-sm text-gray-600 hover:text-red-600 transition-colors" data-id="element-229">
              <Mail className="h-4 w-4 mr-2" data-id="element-230" />
              {supportEmail}
            </a>
            {supportPhone && <a href={`tel:${supportPhone}`} className="flex items-center text-sm text-gray-600 hover:text-red-600 transition-colors" data-id="element-231">
                <Phone className="h-4 w-4 mr-2" data-id="element-232" />
                {supportPhone}
              </a>}
          </div>
          <p className="text-xs text-gray-500 mt-4" data-id="element-233">
            © {new Date().getFullYear()} Pop-Up Store. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}